import { render, staticRenderFns } from "./VManage.vue?vue&type=template&id=48908708&"
import script from "./VManage.vue?vue&type=script&lang=js&"
export * from "./VManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports